(() => {
  const VENUE = "King Drew Magnet High School, 1601 E. 120th St., Los Angeles, CA 90059";

  function eventCardFor(button) {
    return button.closest(".game-card");
  }

  function eventDetails(card) {
    if (!card) return null;
    return {
      id: card.dataset.eventId || "drew-league-game",
      title: `${card.dataset.title || "Drew League Game"} - ${card.dataset.teams || ""}`,
      teams: card.dataset.teams || "Drew League Game",
      start: card.dataset.start || "",
      end: card.dataset.end || "",
      description: "Drew League game. Confirm the time and matchup on the official schedule before arrival."
    };
  }

  function downloadIcs(card) {
    const event = eventDetails(card);
    if (!event || !event.start || !event.end) return;
    const ics = [
      "BEGIN:VCALENDAR",
      "VERSION:2.0",
      "PRODID:-//Drew League//Schedule//EN",
      "BEGIN:VEVENT",
      `UID:${event.id}@drewleague.com`,
      `DTSTAMP:${new Date().toISOString().replace(/[-:]/g, "").replace(/\.\d{3}/, "")}`,
      `DTSTART:${event.start}`,
      `DTEND:${event.end}`,
      `SUMMARY:${event.title}`,
      `LOCATION:${VENUE}`,
      `DESCRIPTION:${event.description}`,
      "END:VEVENT",
      "END:VCALENDAR"
    ].join("\r\n");
    const link = document.createElement("a");
    link.href = URL.createObjectURL(new Blob([ics], { type: "text/calendar" }));
    link.download = `${event.id}.ics`;
    link.click();
    URL.revokeObjectURL(link.href);
  }

  function initCalendar(root = document) {
    const dialog = document.querySelector("#calendar-dialog");
    if (!dialog) return;

    root.querySelectorAll(".schedule-calendar-button:not([data-calendar-ready])").forEach((button) => {
      button.dataset.calendarReady = "true";
      button.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        const feed = button.dataset.calendarFeed;
        dialog.querySelector("#calendar-dialog-title").textContent = button.dataset.calendarTitle || "Opening Weekend";
        dialog.querySelector('[data-calendar-provider="google"]').href = `https://calendar.google.com/calendar/render?cid=${encodeURIComponent(feed)}`;
        dialog.querySelector('[data-calendar-provider="ical"]').dataset.feed = feed;
        if (!dialog.open) dialog.showModal();
      });
    });

    if (!dialog.dataset.ready) {
      dialog.dataset.ready = "true";
      dialog.querySelectorAll('button[data-calendar-provider]').forEach((button) => {
        button.addEventListener("click", () => {
          window.location.href = button.dataset.feed;
        });
      });
      dialog.querySelector(".calendar-close")?.addEventListener("click", () => dialog.close());
      dialog.addEventListener("click", (event) => {
        if (event.target === dialog) dialog.close();
      });
    }
  }

  function initKingDrew() {
    const chat = document.querySelector(".king-chat");
    if (!chat || chat.dataset.ready) return;
    chat.dataset.ready = "true";
    const state = chat.querySelector(".king-chat-state");
    const body = chat.querySelector(".king-chat-body");
    const form = chat.querySelector(".king-chat-form");
    const input = form?.querySelector("input");
    const answers = [
      { keys: ["team", "teams", "plays", "division", "schedule", "game", "games"], text: "Opening Weekend lists every men's and women's matchup for June 20-21 at King Drew Magnet High School." },
      { keys: ["ticket", "tickets", "free", "rsvp", "attend"], text: "Tickets are free. Join The Drew for ticket alerts and schedule changes." },
      { keys: ["standing", "standings", "record", "rank", "stats"], text: "Stats links: Men's Stats https://ballstar.com/league/14a143be-c6a7-44b9-91cc-4e8870c42400 and Women's Stats https://ballstar.com/league/5f5e0016-c6ca-49c7-94d2-150f81833f8c." },
      { keys: ["merch", "shop", "drop"], text: "Shop official Drew League products through the Shop section." },
      { keys: ["where", "gym", "visit", "address", "location"], text: `${VENUE}. About The Drew has one-click directions.` },
      { keys: ["about", "history", "founded", "1973", "dino"], text: "The Drew started in 1973 and grew into a South Central summer institution. No Excuse. Just Produce." },
      { keys: ["video", "watch", "youtube", "highlight"], text: "Watch features official Drew League highlights, interviews, conversations, and unforgettable moments from the league archive." }
    ];
    const fallback = "Ask me about the schedule, stats, merch, Watch, history, or visiting King Drew.";

    function addMessage(text, type) {
      const message = document.createElement("div");
      message.className = `king-message ${type}`;
      message.textContent = text;
      body.appendChild(message);
      body.scrollTop = body.scrollHeight;
    }

    function ask(question) {
      const clean = question.trim();
      if (!clean) return;
      addMessage(clean, "user");
      const normalized = clean.toLowerCase();
      const match = answers.find((item) => item.keys.some((key) => normalized.includes(key)));
      addMessage(match ? match.text : fallback, "bot");
    }

    state?.addEventListener("change", () => {
      chat.classList.toggle("open", state.checked);
      if (state.checked) input?.focus();
    });
    form?.addEventListener("submit", (event) => {
      event.preventDefault();
      ask(input.value);
      input.value = "";
    });
    chat.querySelectorAll(".king-chip").forEach((chip) => {
      chip.addEventListener("click", () => ask(chip.dataset.question || chip.textContent));
    });
  }

  function init(root = document) {
    document.documentElement.classList.remove("no-js");
    initCalendar(root);
    initKingDrew();
  }

  document.addEventListener("DOMContentLoaded", () => init());
  document.addEventListener("shopify:section:load", (event) => init(event.target));
})();
